// Step de Sucesso do onboarding
import { CheckCircle } from 'lucide-react';
import { Button } from '../common/Button';
import { useNavigate } from 'react-router-dom';

interface SuccessStepProps {
  onComplete: () => void;
}

export function SuccessStep({ onComplete }: SuccessStepProps) {
  const navigate = useNavigate();

  const handleGoToDashboard = () => {
    onComplete();
    navigate('/app');
  };

  return (
    <div className="text-center space-y-6 py-8">
      <div className="w-20 h-20 bg-success-100 dark:bg-success-900/20 rounded-full flex items-center justify-center mx-auto shadow-lg shadow-success-500/30">
        <CheckCircle className="w-12 h-12 text-success-600 dark:text-success-400" />
      </div>
      
      <div className="space-y-3">
        <h2 className="text-3xl font-bold text-gray-900 dark:text-gray-100">
          Empresa Cadastrada com Sucesso!
        </h2>
        <p className="text-lg text-gray-600 dark:text-gray-400 max-w-md mx-auto">
          Sua empresa foi cadastrada e vinculada ao seu usuário. Agora você pode começar a usar o sistema.
        </p>
      </div>
      
      <div className="pt-4">
        <Button variant="primary" size="lg" onClick={handleGoToDashboard} className="px-8">
          Acessar Dashboard
        </Button>
      </div>
    </div>
  );
}
